import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet framework
import { devConfig } from 'config/config'; // Importing development configuration from config module

/**
 * Class representing a view for displaying income data in a table.
 * @extends JetView
 */
export default class tableIncomesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates in the datatable
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            view: 'datatable', // Define the view type as a datatable
            id: 'datatable', // Set the unique identifier for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // Apply CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
            height: screen.width < 820 ? 410 : 0, // Set height based on screen width
            columns: [
                // Define the columns of the datatable
                {
                    id: 'rating', // Unique identifier for the column
                    header: '', // Header text for the column
                    width: 50, // Width of the column
                    height: 25, // Height of the column
                    tooltip: 'Editar', // Tooltip text for the column
                    template: function (obj) {
                        // Template function to render the column
                        // Check if the user has permission to edit
                        if (devConfig.getPermAction('accountingIncomePrint', 'Edit')) {
                            return "<span class='webix_icon wxi-close printer'></span>"; // Return edit icon if permitted
                        } else {
                            return ''; // Return empty string if not permitted
                        }
                    },
                },
                {
                    id: 'Id', // Unique identifier for the column
                    header: 'ID', // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Sort type for the column
                    hidden: true, // Hide this column
                },
                {
                    id: 'Consecutive', // Unique identifier for the column
                    header: _('Consecutivo'), // Header text with localization
                    width: 100, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'Description', // Unique identifier for the column
                    header: _('Descripción'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'CreatedLocalDate', // Unique identifier for the column
                    header: _('Fecha de Creación'), // Header text with localization
                    fillspace: 0, // Fill space option
                    minWidth: 0, // Minimum width of the column
                    width: 150, // Width of the column
                    sort: 'text', // Sort type for the column
                    format: dateFormat, // Date format for the column
                },
                { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                {
                    id: 'BetShop', // Unique identifier for the column
                    header: _('Punto de Venta'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'UserCreated', // Unique identifier for the column
                    header: _('Creador'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'DocumentID', // Unique identifier for the column
                    header: _('Documento ID'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                { id: 'Account', header: _('Cuenta'), width: 150, sort: 'int' }, // Account column
                {
                    id: 'Concept', // Unique identifier for the column
                    header: _('Concepto'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                { id: 'Amount', header: _('Valor'), width: 150, sort: 'int' }, // Amount column
                { id: 'Tax', header: _('Impuesto'), width: 150, sort: 'int' }, // Tax column
                {
                    id: 'Retraction', // Unique identifier for the column
                    header: _('Retracción'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
            ],
            onClick: {
                // Define click event handlers
                edit: function (euv, id) {
                    // Handler for edit button click
                    vthis.app.callEvent('openEdit', [{}]); // Trigger the openEdit event
                },
                printer: function (euv, id) {
                    // Handler for printer button click
                    var vvthis = this; // Preserve context
                    var item = vvthis.getItem(id); // Get the clicked item
                    webix
                        .ajax() // Perform an AJAX request
                        .headers({
                            'Content-type': 'application/json', // Set content type for the request
                        })
                        .post(
                            devConfig.geturlApi() + 'Accounting/GetDetailsIncomePDF', // API endpoint
                            '{ "Id":' + item.Id + '}', // Request payload
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handler
                                    webix.message('Error! '); // Display error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handler
                                    data = JSON.parse(text); // Parse the response data
                                    webix
                                        .ui({
                                            // Create a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: _('Soporte'), // Label for the window
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button label
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowfact2').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowfact2', // Unique identifier for the window
                                            modal: true, // Make the window modal
                                            position: 'center', // Center the window
                                            body: {
                                                rows: [
                                                    {
                                                        template:
                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for displaying PDF
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                    var reader = new FileReader(); // Create a FileReader instance
                                    reader.onload = function (event) {
                                        // On load event for the reader
                                        $$('pdf').clear(); // Clear previous PDF data
                                        $$('pdf').parse({
                                            data: event.target.result, // Parse new PDF data
                                        });
                                    };
                                    // Function to convert base64 to Blob
                                    function b64toBlob(b64Data, contentType, sliceSize) {
                                        contentType = contentType || ''; // Default content type
                                        sliceSize = sliceSize || 512; // Default slice size
                                        var byteCharacters = atob(b64Data); // Decode base64 string
                                        var byteArrays = []; // Array to hold byte arrays
                                        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                                            var slice = byteCharacters.slice(offset, offset + sliceSize); // Slice the byte characters
                                            var byteNumbers = new Array(slice.length); // Create an array for byte numbers
                                            for (var i = 0; i < slice.length; i++) {
                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                            }
                                            var byteArray = new Uint8Array(byteNumbers); // Create a Uint8Array from byte numbers
                                            byteArrays.push(byteArray); // Add to byte arrays
                                        }
                                        var blob = new Blob(byteArrays, {
                                            type: contentType, // Create a Blob with the specified content type
                                        });
                                        return blob; // Return the Blob
                                    }
                                    var contentType = 'application/pdf'; // Define content type for PDF
                                    var b64Data = data.Pdf; // Get base64 data from response
                                    var blob = b64toBlob(b64Data, contentType); // Convert base64 to Blob
                                    var file = window.URL.createObjectURL(blob); // Create a URL for the Blob
                                    console.log(blob); // Log the Blob for debugging
                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                    var printWindow = window.open(
                                        file,
                                        '',
                                        'width=800,height=500', // Open a new window for printing
                                    );
                                    printWindow.print(); // Trigger print dialog
                                },
                            },
                        );
                },
            },
            on: {
                // Define event handlers for the datatable
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Set load ahead option
            datafetch: devConfig.getDefaultDataFetch(), // Set default data fetch configuration
            pager: 'pagerA', // Set the pager ID for pagination
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Getting localization service
        var url = devConfig.geturlApi() + 'Accounting/GetIncomes'; // API endpoint for fetching incomes
        var filter = ''; // Filter variable for API requests
        var datePopup = []; // Array to hold data for date popup
        var datePopup2 = []; // Array to hold data for cost center popup
        var datePopup3 = []; // Array to hold data for concepts popup
        var datePopup4 = []; // Array to hold data for types center position popup
        var popupAdd = ''; // Variable to hold the popup window instance
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() + // Getting the current year
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) + // Getting the current month
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2); // Getting the current date

        webix
            .ajax() // Initiating an AJAX request
            .headers({
                'Content-type': 'application/json', // Setting content type to JSON
            })
            .post(devConfig.geturlApi() + 'Accounting/GetBetShopSelect', '', { // Requesting bet shop selection data
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error handling
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text); // Parsing the response text
                    for (var i = 0; i < resp.Data.length; i++) { // Iterating through response data
                        resp.Data[i].id = resp.Data[i].Id; // Mapping Id to id
                        resp.Data[i].value = resp.Data[i].Name; // Mapping Name to value
                    }
                    datePopup = resp.Data; // Storing bet shop data
                    webix
                        .ajax() // Initiating another AJAX request
                        .headers({
                            'Content-type': 'application/json', // Setting content type to JSON
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetCostCenterSelect', '', { // Requesting cost center selection data
                            error: function (text, data, XmlHttpRequest) {
                                webix.message('Error! '); // Error handling
                            },
                            success: function (text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parsing the response text
                                datePopup2 = resp.Data; // Storing cost center data
                                webix
                                    .ajax() // Initiating another AJAX request
                                    .headers({
                                        'Content-type': 'application/json', // Setting content type to JSON
                                    })
                                    .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', { // Requesting concepts selection data
                                        error: function (text, data, XmlHttpRequest) {
                                            webix.message('Error! '); // Error handling
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            var resp = JSON.parse(text); // Parsing the response text
                                            datePopup3 = resp.Data; // Storing concepts data
                                            webix
                                                .ajax() // Initiating another AJAX request
                                                .headers({
                                                    'Content-type': 'application/json', // Setting content type to JSON
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect',
                                                    '{"Type":3}', // Sending request with Type parameter
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error handling
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text); // Parsing the response text
                                                            datePopup4 = resp.Data; // Storing types center position data
                                                            popupAdd = webix.ui({ // Creating a new popup window
                                                                view: 'window',
                                                                width: 750,
                                                                id: 'AddIncomes', // ID for the popup
                                                                head: {
                                                                    view: 'toolbar',
                                                                    cols: [
                                                                        {
                                                                            view: 'label',
                                                                            label: _('Añadir Ingreso'), // Label for adding income
                                                                        },
                                                                        {
                                                                            view: 'icon',
                                                                            icon: 'wxi-close', // Close icon
                                                                            click: function () {
                                                                                this.getTopParentView().hide(); // Close the popup
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                                position: 'center', // Center position of the popup
                                                                modal: true, // Modal popup
                                                                body: {
                                                                    view: 'form',
                                                                    id: 'addform', // ID for the form
                                                                    elements: [
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'checkbox',
                                                                                    label: _('Es punto de venta?'), // Checkbox for bet shop
                                                                                    name: 'IsBetShop', // Name for the checkbox
                                                                                    value: 1, // Default value
                                                                                    labelWidth: 140,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Descripción'), // Text input for description
                                                                                    name: 'Description', // Name for the input
                                                                                    labelWidth: 140,
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Fecha de Creación'), // Text input for creation date
                                                                                    labelWidth: 140,
                                                                                    name: 'CreatedLocalDate', // Name for the input
                                                                                    value: createdLocalDate, // Default value
                                                                                    readonly: true, // Read-only field
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Tipo de Ingreso'), // Combo box for income type
                                                                                    name: 'TypeIncome', // Name for the combo
                                                                                    labelWidth: 140,
                                                                                    options: datePopup4, // Options for the combo
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Punto de Venta'), // Combo box for bet shop
                                                                                    name: 'BetShop', // Name for the combo
                                                                                    labelWidth: 140,
                                                                                    options: datePopup, // Options for the combo
                                                                                    id: 'BetShop', // ID for the combo
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Centro de costos'), // Combo box for cost center
                                                                                    name: 'CostCenter', // Name for the combo
                                                                                    labelWidth: 140,
                                                                                    options: datePopup2, // Options for the combo
                                                                                    id: 'CostCenter', // ID for the combo
                                                                                    hidden: true, // Hidden by default
                                                                                    required: false, // Not required
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Concepto'), // Combo box for concept
                                                                                    name: 'Concept', // Name for the combo
                                                                                    labelWidth: 140,
                                                                                    options: datePopup3, // Options for the combo
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Documento ID'), // Text input for document ID
                                                                                    name: 'DocumentID', // Name for the input
                                                                                    labelWidth: 140,
                                                                                    required: false, // Not required
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Valor'), // Text input for value
                                                                                    name: 'Value', // Name for the input
                                                                                    type: 'number', // Input type number
                                                                                    labelWidth: 100,
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Impuesto'), // Text input for tax
                                                                                    name: 'Iva', // Name for the input
                                                                                    type: 'number', // Input type number
                                                                                    labelWidth: 100,
                                                                                    required: true, // Required field
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Retracción'), // Text input for retraction
                                                                                    name: 'Retraccion', // Name for the input
                                                                                    type: 'number', // Input type number
                                                                                    labelWidth: 100,
                                                                                    required: true, // Required field
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            cols: [
                                                                                {
                                                                                    view: 'button',
                                                                                    value: _('Cancelar'), // Cancel button
                                                                                    click: function () {
                                                                                        this.getTopParentView().hide(); // Close the popup
                                                                                        $$('addform').setValues( // Reset form values
                                                                                            $(
                                                                                                'addform',
                                                                                            ).getCleanValues(),
                                                                                        );
                                                                                    },
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    type: 'form',
                                                                                    value: _('Guardar'), // Save button
                                                                                    click: function ($e) {
                                                                                        var values =
                                                                                            $$('addform').getValues(); // Get form values
                                                                                        if ($$('addform').validate()) { // Validate form
                                                                                            webix
                                                                                                .ajax() // Initiating an AJAX request
                                                                                                .headers({
                                                                                                    'Content-type':
                                                                                                        'application/json', // Setting content type to JSON
                                                                                                })
                                                                                                .post(
                                                                                                    devConfig.geturlApi() +
                                                                                                    'Accounting/Incomes',
                                                                                                    '{"IsBetShop":"' +
                                                                                                    values.IsBetShop +
                                                                                                    '", "Description":"' +
                                                                                                    values.Description +
                                                                                                    '", "CreatedLocalDate":"' +
                                                                                                    values.CreatedLocalDate +
                                                                                                    '", "TypeIncome":"' +
                                                                                                    values.TypeIncome +
                                                                                                    '"  , "BetShop":"' +
                                                                                                    values.BetShop +
                                                                                                    '" , "CostCenter":"' +
                                                                                                    values.CostCenter +
                                                                                                    '" , "Concept":"' +
                                                                                                    values.Concept +
                                                                                                    '" , "DocumentID":"' +
                                                                                                    values.DocumentID +
                                                                                                    '"  , "Value":"' +
                                                                                                    values.Value +
                                                                                                    '", "Iva":"' +
                                                                                                    values.Iva +
                                                                                                    '", "Retraccion":"' +
                                                                                                    values.Retraccion +
                                                                                                    '"}', // Sending form data
                                                                                                    {
                                                                                                        error: function (
                                                                                                            text,
                                                                                                            data,
                                                                                                            XmlHttpRequest,
                                                                                                        ) {
                                                                                                            webix.message(
                                                                                                                _(
                                                                                                                    'Error! ',
                                                                                                                ),
                                                                                                            ); // Error handling
                                                                                                        },
                                                                                                        success:
                                                                                                            function (
                                                                                                                text,
                                                                                                                data,
                                                                                                                XmlHttpRequest,
                                                                                                            ) {
                                                                                                                webix.message(
                                                                                                                    _(
                                                                                                                        'Ingreso Agregado',
                                                                                                                    ), // Success message
                                                                                                                );
                                                                                                                grid.clearAll(); // Clear grid data
                                                                                                                grid.load(
                                                                                                                    url +
                                                                                                                    '?start=0&count=' +
                                                                                                                    grid
                                                                                                                        .data
                                                                                                                        .$pagesize +
                                                                                                                    filter, // Reload grid data
                                                                                                                );
                                                                                                                webix
                                                                                                                    .ui(
                                                                                                                        {
                                                                                                                            view: 'window',
                                                                                                                            width: 500,
                                                                                                                            height: 700,
                                                                                                                            head: {
                                                                                                                                view: 'toolbar',
                                                                                                                                cols: [
                                                                                                                                    {
                                                                                                                                        view: 'label',
                                                                                                                                        label: _(
                                                                                                                                            'Factura', // Label for invoice
                                                                                                                                        ),
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                        view: 'button',
                                                                                                                                        label: 'X', // Close button for invoice window
                                                                                                                                        width: 100,
                                                                                                                                        align: 'right',
                                                                                                                                        click: "$$('windowfact2').close();", // Close invoice window
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                            id: 'windowfact2', // ID for the invoice window
                                                                                                                            modal: true, // Modal window
                                                                                                                            position:
                                                                                                                                'center', // Center position of the window
                                                                                                                            body: {
                                                                                                                                rows: [
                                                                                                                                    {
                                                                                                                                        template:
                                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Template for PDF display
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                        },
                                                                                                                    )
                                                                                                                    .show(); // Show invoice window
                                                                                                                var reader =
                                                                                                                    new FileReader(); // FileReader instance for reading files
                                                                                                                reader.onload =
                                                                                                                    function (
                                                                                                                        event,
                                                                                                                    ) {
                                                                                                                        $(
                                                                                                                            'pdf',
                                                                                                                        ).clear(); // Clear PDF display
                                                                                                                        $(
                                                                                                                            'pdf',
                                                                                                                        ).parse(
                                                                                                                            {
                                                                                                                                data: event
                                                                                                                                    .target
                                                                                                                                    .result, // Parsing PDF data
                                                                                                                            },
                                                                                                                        );
                                                                                                                    };
                                                                                                                function b64toBlob(
                                                                                                                    b64Data,
                                                                                                                    contentType,
                                                                                                                    sliceSize,
                                                                                                                ) {
                                                                                                                    contentType =
                                                                                                                        contentType ||
                                                                                                                        ''; // Default content type
                                                                                                                    sliceSize =
                                                                                                                        sliceSize ||
                                                                                                                        512; // Default slice size
                                                                                                                    var byteCharacters =
                                                                                                                        atob(
                                                                                                                            b64Data, // Decoding base64 data
                                                                                                                        );
                                                                                                                    var byteArrays =
                                                                                                                        []; // Array to hold byte arrays
                                                                                                                    for (
                                                                                                                        var offset = 0;
                                                                                                                        offset <
                                                                                                                        byteCharacters.length;
                                                                                                                        offset +=
                                                                                                                            sliceSize
                                                                                                                    ) {
                                                                                                                        var slice =
                                                                                                                            byteCharacters.slice(
                                                                                                                                offset,
                                                                                                                                offset +
                                                                                                                                sliceSize,
                                                                                                                            ); // Slicing byte characters
                                                                                                                        var byteNumbers =
                                                                                                                            new Array(
                                                                                                                                slice.length,
                                                                                                                            ); // Array to hold byte numbers
                                                                                                                        for (
                                                                                                                            var i = 0;
                                                                                                                            i <
                                                                                                                            slice.length;
                                                                                                                            i++
                                                                                                                        ) {
                                                                                                                            byteNumbers[
                                                                                                                                i
                                                                                                                                ] =
                                                                                                                                slice.charCodeAt(
                                                                                                                                    i, // Getting char code
                                                                                                                                );
                                                                                                                        }
                                                                                                                        var byteArray =
                                                                                                                            new Uint8Array(
                                                                                                                                byteNumbers, // Creating Uint8Array from byte numbers
                                                                                                                            );
                                                                                                                        byteArrays.push(
                                                                                                                            byteArray, // Pushing byte array to the array
                                                                                                                        );
                                                                                                                    }
                                                                                                                    var blob =
                                                                                                                        new Blob(
                                                                                                                            byteArrays,
                                                                                                                            {
                                                                                                                                type: contentType, // Creating a Blob from byte arrays
                                                                                                                            },
                                                                                                                        );
                                                                                                                    return blob; // Returning the Blob
                                                                                                                }
                                                                                                                var contentType =
                                                                                                                    'application/pdf'; // Setting content type for PDF
                                                                                                                var b64Data =
                                                                                                                    data.Pdf; // Base64 data for PDF
                                                                                                                var blob =
                                                                                                                    b64toBlob(
                                                                                                                        b64Data,
                                                                                                                        contentType, // Converting base64 to Blob
                                                                                                                    );
                                                                                                                var file =
                                                                                                                    window.URL.createObjectURL(
                                                                                                                        blob, // Creating object URL for the Blob
                                                                                                                    );
                                                                                                                console.log(
                                                                                                                    blob, // Logging the Blob
                                                                                                                );
                                                                                                                document.querySelector(
                                                                                                                    'iframe',
                                                                                                                ).src =
                                                                                                                    file; // Setting iframe source to the file
                                                                                                                var printWindow =
                                                                                                                    window.open(
                                                                                                                        file,
                                                                                                                        '',
                                                                                                                        'width=800,height=500', // Opening print window
                                                                                                                    );
                                                                                                                printWindow.print(); // Triggering print
                                                                                                            },
                                                                                                    },
                                                                                                );
                                                                                            $$('addform').setValues( // Resetting form values
                                                                                                $(
                                                                                                    'addform',
                                                                                                ).getCleanValues(),
                                                                                            );
                                                                                            this.getTopParentView().hide(); // Closing the popup
                                                                                        } else {
                                                                                            webix.message({
                                                                                                title: _('¡Error!'), // Error message title
                                                                                                type: 'alert-error',
                                                                                                text: _(
                                                                                                    'Completa los campos...', // Error message text
                                                                                                ),
                                                                                            });
                                                                                        }
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                    elementsConfig: {
                                                                        on: {
                                                                            onChange: function () { // Change event for checkbox
                                                                                if (this.getValue() == '1') { // If checkbox is checked
                                                                                    $$('CostCenter').hide(); // Hide cost center
                                                                                    $$('BetShop').show(); // Show bet shop
                                                                                } else {
                                                                                    if (this.getValue() == '0') { // If checkbox is unchecked
                                                                                        $$('CostCenter').show(); // Show cost center
                                                                                        $$('BetShop').hide(); // Hide bet shop
                                                                                    }
                                                                                }
                                                                                this.validate(); // Validate the form
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            });
                                                        },
                                                    },
                                                );
                                        },
                                    });
                            },
                        });
                },
            });

        // Listen for the 'incomes:filter' event on the app instance
        this.on(this.app, 'incomes:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty string to build query parameters

            // Iterate over each key-value pair in the object
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'Datepicker' case
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFro=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle other cases except for 'Date'
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add key-value pair to query
                        } else {
                            // Handle the 'Date' case specifically
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(
                                    ' 00:00:00',
                                    '', // Remove time part from date
                                );
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate over each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date case
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() + // Format date to YYYY:MM:DD HH:MM:SS
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    // Handle 'end' date case
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with constructed query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters after sorting is completed
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    filter + // Additional filter parameters
                    '&sort[' +
                    by + // Sort by the specified column
                    ']=' +
                    dir, // Sort direction (ascending or descending)
            );
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Retrieve the clicked item based on its ID
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item's ID
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid data filtered by the selected player's ID
            grid.load(
                url +
                    '?start=0&count=' +
                    grid.data.$pagesize + // Current page size for pagination
                    '&PlayerId=' +
                    Id, // Filter by the selected player's ID
            );
        });
        // Create a popup window for editing income entries
        var popup = webix.ui({
            view: 'window', // Define the view type as a window
            width: 750, // Set the width of the window
            id: 'EditIncomes', // Unique identifier for the window
            head: {
                view: 'toolbar', // Toolbar at the top of the window
                cols: [
                    { view: 'label', label: _('Editar Ingreso') }, // Label for the window title
                    {
                        view: 'icon', // Close icon in the toolbar
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to close the window
                            this.getTopParentView().hide(); // Hide the window
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Form inside the window
                id: 'editForm', // Unique identifier for the form
                elements: [
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'checkbox', // Checkbox for indicating if it's a point of sale
                                label: _('Es punto de venta?'), // Checkbox label
                                name: 'IsBetShop', // Name of the checkbox
                                id: 'IsBetShop', // Unique identifier for the checkbox
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the checkbox read-only
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for ID
                                label: 'ID', // Label for the input
                                name: 'Id', // Name of the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for description
                                label: _('Descripción'), // Label for the input
                                name: 'Description', // Name of the input
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for creation date
                                label: _('Fecha de Creación'), // Label for the input
                                labelWidth: 140, // Width of the label
                                name: 'CreatedLocalDate', // Name of the input
                                readonly: true, // Make the input read-only
                            },
                            {
                                view: 'text', // Text input for income type
                                label: _('Tipo de Ingreso'), // Label for the input
                                name: 'TypeIncome', // Name of the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for document ID
                                label: _('Documento ID'), // Label for the input
                                name: 'DocumentID', // Name of the input
                                readonly: true, // Make the input read-only
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'combo', // Combo box for point of sale
                                label: _('Punto de Venta'), // Label for the combo
                                name: 'BetShop', // Name of the combo
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the combo read-only
                                id: 'BetShop', // Unique identifier for the combo
                            },
                            {
                                view: 'combo', // Combo box for cost center
                                label: _('Centro de costos'), // Label for the combo
                                name: 'CostCenter', // Name of the combo
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the combo read-only
                                id: 'CostCenter', // Unique identifier for the combo
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'combo', // Combo box for concept
                                label: _('Concepto'), // Label for the combo
                                name: 'Concept', // Name of the combo
                                labelWidth: 140, // Width of the label
                                readonly: true, // Make the combo read-only
                            },
                            {
                                view: 'text', // Text input for value
                                label: _('Valor'), // Label for the input
                                name: 'Value', // Name of the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        margin: 10, // Margin around the element
                        cols: [
                            {
                                view: 'text', // Text input for VAT
                                label: 'IVA', // Label for the input
                                name: 'Iva', // Name of the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                            {
                                view: 'text', // Text input for retraction
                                label: _('Retracción'), // Label for the input
                                name: 'Retraccion', // Name of the input
                                type: 'number', // Input type as number
                                labelWidth: 140, // Width of the label
                            },
                        ],
                    },
                    {
                        cols: [
                            // Buttons at the bottom of the form
                            {
                                view: 'button', // Cancel button
                                value: _('Cancelar'), // Button label
                                click: function () {
                                    // Click event for cancel button
                                    this.getTopParentView().hide(); // Hide the window
                                   $$('editForm').setValues(
                                        // Reset form values
                                       $$('editForm').getCleanValues(),
                                    );
                                },
                            },
                            {
                                view: 'button', // Save button
                                type: 'form', // Button type as form submission
                                value: _('Guardar'), // Button label
                                click: function ($e) {
                                    // Click event for save button
                                    var values =$$('editForm').getValues(); // Get form values
                                    webix // Perform an AJAX request to save the data
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for saving income
                                                'Accounting/Incomes',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "IsBetShop":"' +
                                                values.IsBetShop +
                                                '", "Description":"' +
                                                values.Description +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "TypeIncome":"' +
                                                values.TypeIncome +
                                                '"  , "CostCenter":"' +
                                                values.CostCenter +
                                                '"  , "BetShop":"' +
                                                values.BetShop +
                                                '"  , "DocumentID":"' +
                                                values.DocumentID +
                                                '"  , "Value":"' +
                                                values.Value +
                                                '", "Iva":"' +
                                                values.Iva +
                                                '", "Retraccion":"' +
                                                values.Retraccion +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Error callback
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Success callback
                                                    webix.message(
                                                        _('Ingreso Actualizado'), // Show success message
                                                    );
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + // Reload grid data
                                                            '?start=0&count=' +
                                                            grid.data.$pagesize +
                                                            filter,
                                                    );
                                                },
                                            },
                                        );
                                   $$('editForm').setValues(
                                        // Reset form values after saving
                                       $$('editForm').getCleanValues(),
                                    );
                                    this.getTopParentView().hide(); // Hide the window
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Event listener for the 'AddIncome:button' event
        this.on(this.app, 'AddIncome:button', (filter) => {
            // Check if all date popups have values
            if (datePopup.length > 0 && datePopup2.length > 0 && datePopup3.length > 0 && datePopup2.length > 0) {
                // Clear any previous validation errors on the add form
                $$('addform').clearValidation();
                // Show the add income popup
                popupAdd.show();
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message
                });
            }
        });

        // Event listener for the 'openEdit' event
        this.on(this.app, 'openEdit', (filterData) => {
            // Check if all date popups have values
            if (datePopup.length > 0 && datePopup2.length > 0 && datePopup3.length > 0 && datePopup2.length > 0) {
                // Show the edit popup
                popup.show();
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'), // Error message text
                    title: _('¡Error!'), // Error message title
                    type: 'alert-error', // Type of message
                });
            }
        });
        // Bind the edit form to the data table for data synchronization
       $$('editForm').bind($$('datatable'));

        // Attach an event listener for the 'onFocus' event of the 'EditIncomes' element
        $$('EditIncomes').attachEvent('onFocus', function () {
            // Delay the execution of the following function by 50 milliseconds
            webix.delay(
                function () {
                    // Check if the 'IsBetShop' value is 1
                    if ($$('IsBetShop').getValue() == 1) {
                        // Hide the 'CostCenter' element and show the 'BetShop' element
                        $$('CostCenter').hide();
                        $$('BetShop').show();
                    } else {
                        // Check if the 'IsBetShop' value is 0
                        if ($$('IsBetShop').getValue() == 0) {
                            // Show the 'CostCenter' element and hide the 'BetShop' element
                            $$('CostCenter').show();
                            $$('BetShop').hide();
                        }
                    }
                },
                '', // No context for the delay function
                '', // No additional parameters for the delay function
                50, // Delay duration in milliseconds
            );
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
